/* ATLANTIC Mood — comportamientos propios del tema.
 *
 * Este archivo es NUESTRO, no de Horizon: una actualizacion del tema no se lo
 * lleva. Lo unico que hay que volver a poner tras actualizar es la linea que
 * lo carga en layout/theme.liquid.
 *
 * Contenido:
 *   1. Cerrar el menu lateral al deslizar fuera de el.
 *   2. Forzar en negro la X de cerrar el menu.
 *   3. Carrito: traer las recomendaciones de Shopify y poder anadir desde ahi.
 *   4. Carrito: elegir destino de envio y ver su coste.
 */

(function () {
  'use strict';

  var UMBRAL = 30; // px que hay que desplazar para considerarlo un deslizamiento

  function panelDelMenu() {
    // El panel visible es el que ocupa sitio; se prueban los dos posibles.
    var candidatos = document.querySelectorAll('.menu-drawer, .menu-drawer__navigation');
    for (var i = 0; i < candidatos.length; i++) {
      var r = candidatos[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return candidatos[i];
    }
    return null;
  }

  function menuAbierto() {
    var det = document.getElementById('Details-menu-drawer-container');
    return !!(det && det.open);
  }

  function cerrarMenu() {
    var drawer = document.querySelector('header-drawer');
    if (drawer && typeof drawer.close === 'function') {
      try {
        drawer.close();
        return;
      } catch (e) {
        /* si falla, se usa el respaldo de abajo */
      }
    }
    var det = document.getElementById('Details-menu-drawer-container');
    if (det) det.open = false;
  }

  function dentroDelMenu(x, y) {
    var panel = panelDelMenu();
    if (!panel) return false;
    var r = panel.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  var inicio = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!menuAbierto() || e.touches.length !== 1) {
        inicio = null;
        return;
      }
      var t = e.touches[0];
      // Solo interesa el gesto que empieza FUERA del panel, para no interferir
      // con el desplazamiento del propio menu.
      inicio = dentroDelMenu(t.clientX, t.clientY) ? null : { x: t.clientX, y: t.clientY };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!inicio || !menuAbierto() || e.touches.length !== 1) return;
      var t = e.touches[0];
      var dx = t.clientX - inicio.x;
      var dy = t.clientY - inicio.y;
      if (Math.sqrt(dx * dx + dy * dy) < UMBRAL) return;
      inicio = null;
      cerrarMenu();
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function () {
      inicio = null;
    },
    { passive: true }
  );
})();

/* Keep internal navigation inside the currently selected English market. */
(function preserveEnglishNavigation() {
  if ((document.documentElement.lang || '').toLowerCase().indexOf('en') !== 0) return;

  var internalPath = /^\/(collections|products|pages|policies|account|cart|search)(\/|$)/;

  function localizeLink(link) {
    if (link && link.hasAttribute('hreflang')) return;
    var href = link && link.getAttribute('href');
    if (href && internalPath.test(href)) link.setAttribute('href', '/en' + href);
  }

  function localizeLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = Array.prototype.slice.call(scope.querySelectorAll('a[href]'));

    if (scope.matches && scope.matches('a[href]')) links.unshift(scope);

    links.forEach(localizeLink);
  }

  localizeLinks(document);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') localizeLink(mutation.target);
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) localizeLinks(node);
        });
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['href'], childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest) localizeLink(event.target.closest('a[href]'));
  }, true);
})();

/* 2. La X de cerrar el menu, siempre en negro.
 *    En la portada la cabecera es transparente sobre el hero y el icono
 *    heredaba el blanco, con lo que desaparecia sobre el fondo butter del
 *    menu abierto. No se ha podido ganar la pelea solo con CSS, asi que se
 *    fija por estilo en linea con prioridad, que gana siempre.
 */
(function () {
  'use strict';

  function pintarEnNegro() {
    var nodos = document.querySelectorAll(
      '.menu-drawer__close-button, .menu-drawer__close-button svg, .menu-drawer__close-button svg *'
    );
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].style.setProperty('color', '#111111', 'important');
      if (nodos[i].tagName.toLowerCase() !== 'button') {
        nodos[i].style.setProperty('stroke', '#111111', 'important');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintarEnNegro);
  } else {
    pintarEnNegro();
  }
  // El menu puede repintarse al navegar entre paginas sin recargar.
  document.addEventListener('click', function () {
    setTimeout(pintarEnNegro, 60);
  });
})();

/* ──────────────────────────────────────────────────────────────────────────
 * 3. CARRITO — "También te puede gustar"
 *
 * El hueco vacio lo deja header-actions.liquid. Aqui le pedimos a Shopify sus
 * recomendaciones (seccion atl-cart-recommendations, que ya filtra lo que el
 * visitante tiene en el carrito) y las metemos dentro.
 *
 * Al anadir algo avisamos al tema con el evento 'cart:update', que es el
 * mismo que usa Horizon internamente: al recibirlo vuelve a pintar el carrito
 * entero, asi que la barra de envio gratis, el subtotal y las propias
 * recomendaciones se recalculan solos.
 * ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var SECCION = 'atl-cart-recommendations';

  function raiz() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function cargarRecomendaciones() {
    var huecos = document.querySelectorAll('[data-atl-reco-slot]');

    Array.prototype.forEach.call(huecos, function (hueco) {
      // Las marcas van como propiedades del elemento, no como atributos: el
      // tema repinta el carrito copiando el HTML del servidor y se llevaria
      // por delante cualquier atributo que hubieramos puesto nosotros.
      if (hueco.__atlCargando) return;
      if (hueco.querySelector('.atl-reco')) return;

      var semilla = hueco.getAttribute('data-seed-product');
      if (!semilla) return;
      // Si ya preguntamos por esta semilla y Shopify no devolvio nada, no
      // insistimos (si no, el vigilante del DOM entraria en bucle).
      if (hueco.__atlVacioPara === semilla) return;

      hueco.__atlCargando = true;

      var url =
        raiz() +
        'recommendations/products?section_id=' + SECCION +
        '&product_id=' + encodeURIComponent(semilla) +
        '&limit=8&intent=related';

      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var bloque = doc.querySelector('.atl-reco');
          hueco.__atlCargando = false;
          if (bloque) {
            hueco.innerHTML = '';
            hueco.appendChild(bloque);
          } else {
            hueco.__atlVacioPara = semilla;
          }
        })
        .catch(function () {
          hueco.__atlCargando = false;
          hueco.__atlVacioPara = semilla;
        });
    });
  }

  function avisarAlTema() {
    return fetch(raiz() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: carrito,
          sourceId: 'atl-cart-reco',
          data: { source: 'atl-cart-reco', itemCount: carrito.item_count }
        };
        document.dispatchEvent(ev);
      });
  }

  function anadir(variantId, tarjeta, boton) {
    var error = tarjeta.querySelector('[data-atl-reco-error]');
    if (error) error.setAttribute('hidden', '');
    boton.setAttribute('aria-busy', 'true');

    fetch(raiz() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (d) { return Promise.reject(d); });
      })
      .then(avisarAlTema)
      .catch(function (d) {
        boton.removeAttribute('aria-busy');
        if (!error) return;
        error.textContent = (d && d.description) || (d && d.message) || '';
        if (error.textContent) error.removeAttribute('hidden');
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    // "Añadir" en un producto con tallas → enseñar las tallas
    var abrir = e.target.closest('[data-atl-reco-open-sizes]');
    if (abrir) {
      var caja = abrir.parentNode.querySelector('[data-atl-reco-sizes]');
      if (caja) {
        abrir.setAttribute('hidden', '');
        caja.removeAttribute('hidden');
      }
      return;
    }

    // "Añadir" en un producto sin tallas → directo al carrito
    var directo = e.target.closest('[data-atl-reco-add-direct]');
    if (directo) {
      anadir(directo.getAttribute('data-variant-id'), directo.closest('[data-atl-reco-card]'), directo);
      return;
    }

    // Talla elegida → al carrito
    var talla = e.target.closest('.atl-reco__size');
    if (talla && !talla.disabled) {
      anadir(talla.getAttribute('data-variant-id'), talla.closest('[data-atl-reco-card]'), talla);
    }
  });

  // El carrito se repinta entero cada vez que cambia algo (y tambien al abrir
  // el cajon por primera vez), asi que el hueco reaparece vacio una y otra vez.
  // En lugar de adivinar cuando pasa, vigilamos el documento: en cuanto asoma
  // un hueco sin rellenar, lo rellenamos.
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      cargarRecomendaciones();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('cart:update', function () {
    setTimeout(cargarRecomendaciones, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cargarRecomendaciones);
  } else {
    cargarRecomendaciones();
  }
})();

/* ──────────────────────────────────────────────────────────────────────────
 * 4. CARRITO — DESTINO DE ENVIO
 *
 * El bloque lo pinta snippets/atl-shipping-destination.liquid, ya con el
 * destino que suponemos por el pais del visitante. Aqui solo:
 *   - recordamos el que elija, para que no tenga que repetirlo;
 *   - cambiamos la linea al elegir otro;
 *   - escondemos la barra de envio gratis cuando el destino elegido no entra
 *     en la promocion (Canarias, Ceuta y Melilla, Portugal y resto de la UE
 *     estan excluidos), porque si no le estariamos prometiendo algo que no
 *     va a tener.
 *
 * El carrito se repinta entero cada vez que cambia algo, asi que hay que
 * volver a aplicar la eleccion despues de cada repintado.
 * ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var CLAVE_GUARDADA = 'atlDestinoEnvio';

  function guardado() {
    try {
      return window.localStorage.getItem(CLAVE_GUARDADA) || '';
    } catch (e) {
      // Navegacion privada o cookies bloqueadas: seguimos sin recordar nada.
      return '';
    }
  }

  function guardar(clave) {
    try {
      window.localStorage.setItem(CLAVE_GUARDADA, clave);
    } catch (e) {}
  }

  function plantilla(bloque) {
    // El texto "Envío estándar a {destino}: {precio}" vive en los archivos de
    // idioma. En vez de duplicarlo aqui, lo deducimos de la linea que ya
    // pinto el servidor, sustituyendo las dos partes variables.
    return bloque.getAttribute('data-plantilla') || '';
  }

  function aplicar(bloque, clave, recordar) {
    var opcion = bloque.querySelector('[data-atl-dest-option][data-clave="' + clave + '"]');
    if (!opcion) return;

    var etiqueta = bloque.querySelector('[data-atl-dest-label]');
    if (etiqueta) {
      var texto = plantilla(bloque)
        .replace('__DESTINO__', opcion.getAttribute('data-nombre'))
        .replace('__PRECIO__', opcion.getAttribute('data-precio'));
      etiqueta.textContent = texto;
    }

    bloque.querySelectorAll('[data-atl-dest-option]').forEach(function (o) {
      o.setAttribute('aria-current', o === opcion ? 'true' : 'false');
    });

    bloque.setAttribute('data-destino-actual', clave);
    if (recordar) guardar(clave);

    // El progreso hacia el envio gratis solo tiene sentido donde la promocion
    // aplica. Se esconde solo esa parte: la linea de destino se queda, que es
    // justo lo que necesita quien acaba de descubrir que no le toca.
    var progreso = document.querySelector('[data-atl-ship-progress]');
    if (progreso) {
      var entra = opcion.getAttribute('data-promocion') === 'true';
      if (entra) progreso.removeAttribute('hidden');
      else progreso.setAttribute('hidden', '');
    }

    // El resumen de abajo sigue al destino. Los importes vienen ya calculados
    // y con el formato de la tienda desde el servidor: aqui solo se copian.
    var envio = document.querySelector('[data-atl-total-envio]');
    var total = document.querySelector('[data-atl-total-final]');
    var pie = document.querySelector('[data-atl-footer-total]');
    if (envio) envio.textContent = opcion.getAttribute('data-envio') || '';
    if (total) total.textContent = opcion.getAttribute('data-total') || '';
    if (pie) pie.textContent = opcion.getAttribute('data-total') || '';
    document.querySelectorAll('[data-atl-total-fila]').forEach(function (fila) {
      fila.removeAttribute('hidden');
    });
  }

  function preparar() {
    var bloques = document.querySelectorAll('[data-atl-dest]:not([data-atl-dest-listo])');

    Array.prototype.forEach.call(bloques, function (bloque) {
      bloque.setAttribute('data-atl-dest-listo', '1');

      var elegido = guardado() || bloque.getAttribute('data-destino-inicial') || '';
      if (!elegido) return;
      // Si el destino guardado ya no existe (cambiaron los ajustes), se ignora.
      if (!bloque.querySelector('[data-atl-dest-option][data-clave="' + elegido + '"]')) return;

      aplicar(bloque, elegido, false);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var abrir = e.target.closest('[data-atl-dest-toggle]');
    if (abrir) {
      var bloqueA = abrir.closest('[data-atl-dest]');
      var lista = bloqueA && bloqueA.querySelector('[data-atl-dest-list]');
      if (!lista) return;
      var abierta = !lista.hasAttribute('hidden');
      if (abierta) lista.setAttribute('hidden', '');
      else lista.removeAttribute('hidden');
      abrir.setAttribute('aria-expanded', abierta ? 'false' : 'true');
      return;
    }

    var opcion = e.target.closest('[data-atl-dest-option]');
    if (opcion) {
      var bloqueB = opcion.closest('[data-atl-dest]');
      if (!bloqueB) return;
      aplicar(bloqueB, opcion.getAttribute('data-clave'), true);
      var listaB = bloqueB.querySelector('[data-atl-dest-list]');
      var botonB = bloqueB.querySelector('[data-atl-dest-toggle]');
      if (listaB) listaB.setAttribute('hidden', '');
      if (botonB) botonB.setAttribute('aria-expanded', 'false');
    }
  });

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(preparar).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparar);
  } else {
    preparar();
  }
})();
